<template>
    <div>
        <pp-base-header-sec></pp-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <table class="table table  table-striped table-sm table-slglrs">

                    <tr v-for="item in itemList" v-bind:key="item.id">
                        <td>
                            <router-link 
                            v-if="canOpen === 'can_open' && item.actType === 'REG' && item.hasHtml === 'False'"
                            :to="'/pppViewPdf/' + item.regDbId + '?doctype=' + item.actType" target="_blank">
                            {{ item.title }}
                        </router-link>
                        <router-link 
                            v-else-if="canOpen === 'can_open' && item.actType === 'SLGLRS' && item.hasHtml === 'False'"
                            :to="'/pppViewPdf/' + item.guidPdfUrl + '?doctype=' + item.actType" target="_blank">
                            {{ item.title }}
                        </router-link>
                        <router-link target="_blank" v-else-if="canOpen === 'can_open'"
                            :to="{ path: '/ppp/viewAct/' + item.id }">
                            {{ item.title }}
                        </router-link>
                            <a v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                {{ item.title }}
                            </a>
                            <a v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                {{ item.title }}
                            </a>


                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import PpBaseHeaderSec from '@/base_pages/pp/PpBaseHeaderSec.vue';
import { mapState } from 'vuex'


export default {
    name: "PpLatestPage",
    data() {
        return {
            itemList: [],
            baseApiUrl: window.env.VUE_APP_API_PPP_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        PpBaseHeaderSec,
    },
    computed: {


        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes(this.$route.params.extCode)) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        fetchData() {
            axios.get(this.baseApiUrl + 'ppp/latestActs?productExtCode=' + this.$route.params.extCode).then(response => {
                // console.log(response);
                this.itemList = response.data
            })
        },
    },
    created() {
        // Fetch Data
        this.fetchData();

    },
    beforeCreate: function () {
        document.body.className = 'color_ppp';
    }
}
</script>

<style scoped></style>
